import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Container } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import { find } from 'lodash';

import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';

import { getAccountDetails } from '../../store/selectors/account';
import BookingCard from '../../components/bookings/BookingCard';
import closeIcon from '../../assets/images/close.svg';
import {
  getUpcomingBookings,
  getBookingHistoryByMonth,
  getInProgressBookings
} from '../../store/selectors/bookings';
import BookingHistoryList from '../../components/bookings/BookingHistoryList';
import AsyncContent from '../../components/shared/AsyncContent';
import {
  fetchAllRentals,
  fetchAllCarpoolings
} from '../../store/actions/rentals';

import config from '../../config';
import {
  inProgressStatuses,
  upcomingStatuses
} from './../../utils/rentalStatuses';

const BookingsPage = ({ history }) => {
  const [page, setPage] = useState(1);
  const { t } = useTranslation(['account']);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const tenant = useSelector(state => state.tenant);
  const accountDetails = useSelector(getAccountDetails(tenant.dateFormat));
  const upcomingBookings = useSelector(getUpcomingBookings);
  const inProgressBookings = useSelector(getInProgressBookings);
  const vehicles = useSelector(state => state.vehicles.list);
  const pageCount = useSelector(state =>
    Math.ceil(
      state.rentals.upcomingMeta.total / state.rentals.upcomingMeta.limit
    )
  );

  const useStyles = makeStyles(theme => ({
    root: {
      '& > * + *': {
        marginTop: theme.spacing(4)
      }
    }
  }));
  const classes = useStyles();

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      await dispatch(fetchAllRentals(page));
      setIsLoading(false);
    };

    loadData();
  }, []);

  const handlePageChange = async (event, value) => {
    setPage(value);
    await dispatch(fetchAllRentals(value));
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  const handleBookingClick = id => {
    history.push(`${config.auth.rootUrl}account/bookings/${id}?page=bookings`);
  };

  const handleReturn = () => {
    history.push(config.auth.rootUrl);
  };

  return (
    <div className="bookings-page">
      <Container
        maxWidth="md"
        className="account-page-container future-bookings-container"
      >
        <div className="page-header">
          <Typography component="h1">{t('account:my-bookings')}</Typography>

          <div className="close-button">
            <IconButton onClick={handleReturn}>
              <img src={closeIcon} alt="" width="30" height="30" />
            </IconButton>
          </div>
        </div>

        <Typography component="h2">
          {t('account:bookings-inprogress')}
        </Typography>

        <AsyncContent loading={isLoading}>
          {inProgressBookings && inProgressBookings.length ? (
            <div className="future-bookings-list">
              {inProgressBookings.map(booking => (
                <BookingCard
                  key={`booking-${booking.id}`}
                  rental={booking}
                  startTime={booking.reservation_start_time}
                  endTime={booking.reservation_end_time}
                  vehicle={find(vehicles, { id: booking.vehicle_id })}
                  status={booking.status}
                  onClick={() => handleBookingClick(booking.id)}
                />
              ))}
            </div>
          ) : (
            <div className="no-booking">{t('account:no-booking')}</div>
          )}
        </AsyncContent>
        <br />
        <Typography component="h2">{t('account:bookings-upcoming')}</Typography>

        <AsyncContent loading={isLoading}>
          {upcomingBookings && upcomingBookings.length ? (
            <div className="future-bookings-list">
              {upcomingBookings.map(booking => (
                <BookingCard
                  key={`booking-${booking.id}`}
                  startTime={booking.reservation_start_time}
                  endTime={booking.reservation_end_time}
                  rental={booking}
                  vehicle={find(vehicles, { id: booking.vehicle_id })}
                  status={booking.status}
                  onClick={() => handleBookingClick(booking.id)}
                />
              ))}
            </div>
          ) : (
            <div className="no-booking">{t('account:no-upcoming-booking')}</div>
          )}
        </AsyncContent>

        <div className="pagination">
          <Pagination
            defaultPage={1}
            siblingCount={1}
            boundaryCount={2}
            shape="rounded"
            count={pageCount}
            page={page}
            onChange={handlePageChange}
          />
        </div>
      </Container>
    </div>
  );
};

export default withRouter(BookingsPage);
